function obtenerPermisos(usuario, modulo) {
  if (modulo === 'documento_cron' && usuario && usuario.email) {
    const allowedEmails = ['desarrollo@fluxsolar.cl', 'v.cordova@fluxsolar.cl'];
    if (allowedEmails.includes(usuario.email)) {
      return { lectura: true, escritura: true, eliminar: true };
    }
  }
  if (usuario && usuario.rol_modulo_permisos && Array.isArray(usuario.rol_modulo_permisos)) {
    return usuario.rol_modulo_permisos.find(
      (c) => c.codigo_rol == usuario.codigo_rol && c.nombre_modulo_permiso == modulo
    )
  }
  return {}
}

export const permiso = {
  obtenerPermisos
}